import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ActualizacionService } from './core/services/actualizacion.service';
import { ActualizacionBannerComponent } from './shared/components/actualizacion-banner/actualizacion-banner';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ActualizacionBannerComponent],
  template: `
    <router-outlet />
    <app-actualizacion-banner />
  `,
})
export class App {
  constructor() {
    // El banner vive fuera del shell para que también aparezca en el login.
    inject(ActualizacionService).iniciar();
  }
}
